import { render, staticRenderFns } from "./lkuArinvdeffered.vue?vue&type=template&id=a5b13ca6"
import script from "./lkuArinvdeffered.vue?vue&type=script&lang=js"
export * from "./lkuArinvdeffered.vue?vue&type=script&lang=js"
import style0 from "./lkuArinvdeffered.vue?vue&type=style&index=0&id=a5b13ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports